// extracted by mini-css-extract-plugin
module.exports = {"container":"it","title":"iu"};